// extracted by mini-css-extract-plugin
module.exports = {"modal":"components-base-Modal-Modal__modal--QOdJU"};